/**
 * @generated SignedSource<<d4db86ef7dfe7561ba954da714844b9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShopBreadcrumbs_landingPage$data = {
  readonly title: string | null;
  readonly " $fragmentType": "ShopBreadcrumbs_landingPage";
};
export type ShopBreadcrumbs_landingPage$key = {
  readonly " $data"?: ShopBreadcrumbs_landingPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShopBreadcrumbs_landingPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShopBreadcrumbs_landingPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "LandingPage",
  "abstractKey": null
};

(node as any).hash = "737f14e41dae051207ffadd92a2fda81";

export default node;
